import { Component, Input, input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { IahResiduelPipe } from '../../../pipes/iah-residuel.pipe';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';
import { IahResiduelStatutPipe } from '../../../pipes/iah-residuel-statut.pipe';

@Component({
  selector: 'app-traitement-data-iahr',
  standalone: true,
  imports: [
    TraitementDataComponent,
    IahResiduelPipe,
    IahResiduelStatutPipe,
    ALaDateDuPipe
  ],
  templateUrl: './traitement-data-iahr.component.html',
  styleUrl: './traitement-data-iahr.component.scss',
})
export class TraitementDataIahrComponent {
  @Input() patient: Patient | undefined;
}
